export default __webpack_public_path__ + "static/node_runner_tablet-5a04bd035b8923d80a7ad33d68d19b7f.png";